module.exports = __webpack_public_path__ + "static/endling-c2c0ce1a25bf4122e11ce7ae00505cb1.png";